<template>
    <div class="comp-banner">
        <div v-if="!d_show">
			<slot></slot>          
        </div>
		<div v-show="d_show">
	        <div :id='c_get_iframe_id'>
        	</div>    
		</div>
    </div>
</template>

<script>
export default {
	name: "banner",
	components: {
	},
	data: function() {
		return {		
			d_show: false,
			d_slot: null,			
		};
	},
	props: {
		p_section: { type: String, default: () => "" },
		p_index: { type: Number, default: () => 0 }	
	},	
	watch: {		
	}, 
	methods: {				
	},
	computed: {	
		c_get_iframe_id: function(){
			this.d_slot = GetSlotBySectionAndIndex(this.p_section, this.p_index);		
			return this.d_slot ? this.d_slot.Id : "";
		}			
	},
	mounted: function() {
		// // GOOGLE TAG FICHA PELICULA		
		var _ = this;		
		if(_.d_slot){
			googletag.cmd.push(function() { googletag.display(_.d_slot.Id); });			
		}
	},
	updated: function(){
	}    
}
</script>




// WEBPACK FOOTER //
// src/components/Banner.vue